import { FormDocument } from './form-document.type';
import { FormTemplate } from './form-template.type';
import { DocumentInfo } from './document-info.type';

/**
 * type for a documentData, used for passing details about the loaded document around
 */

export interface DocumentData extends DocumentInfo {
  template?: FormTemplate;
  document?: FormDocument;
}
